export default __webpack_public_path__ + "static/media/ken.38b24edc.webp";